import './TrialLink.sass';

import React, { FC } from 'react';
import copyToClipboard from 'copy-text-to-clipboard';
import { Block, Button, List, ListItem } from '$uikit';
import { TrialLinkProps } from '$core/TrialLinks/TrialLink/TrialLink.interface';
import { confirmSheet, format, formatDate } from '$utils';
import { useTranslator } from '$hooks';
import { toastActions } from '$store/toast';
import { useDispatch } from 'react-redux';
import { trialLinksActions } from '$store/trialLinks';

export const TrialLink: FC<TrialLinkProps> = ({ link }) => {
  const t = useTranslator();
  const dispatch = useDispatch();

  const handleDeleteLink = async () => {
    if (await confirmSheet('You are about to delete this link. Are you sure?')) {
      dispatch(trialLinksActions.deleteTrialLink(link.id));
    }
  };

  const handleCopyLink = () => {
    copyToClipboard(origin + '/trial/' + link.hash);
    dispatch(toastActions.setToastSuccess(t('copied')));
  };

  return (
    <Block className="TrialLink">
      <div className="TrialLink__title">
        {link.name} {t('trial_link_title', { count: link.period })}
      </div>
      <List className="TrialLink" mode="alternative">
        <ListItem indicator={format(new Date(link.createdAt * 1000), 'dd MMM yyyy')}>
          {t('trial_link_link_created')}
        </ListItem>
        <ListItem
          indicator={
            link.activeAt
              ? format(new Date(link.activeAt * 1000), 'dd MMM yyyy')
              : t('trial_link_without_limit')
          }
        >
          {t('trial_link_link_expires')}
        </ListItem>
        <ListItem indicator={link.limit || t('trial_link_without_limit')}>
          {t('trial_link_offer_limit')}
        </ListItem>
        <ListItem indicator={link.activated || t('trial_link_not_claimed_yet')}>
          {t('trial_link_claims_count')}
        </ListItem>
      </List>
      <div className="TrialLink__footer">
        <Button onClick={handleDeleteLink} size="medium" mode="secondary">
          {t('trial_link_delete')}
        </Button>
        <Button size="medium" mode="secondary" onClick={handleCopyLink}>
          {t('trial_link_copy_link')}
        </Button>
      </div>
    </Block>
  );
};
